import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import createStore from '@/redux/prodStore';
import reportWebVitals from './reportWebVitals';
import AuthProvider from './auth/AuthProvider';

const { store /* , persistor */ } = createStore();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<Provider store={store}>
		{/* <PersistGate persistor={persistor}>
		</PersistGate> */}
		<AuthProvider>
			<App />
		</AuthProvider>
	</Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
